import {
  type BetterDocSpecialty,
  isSpecialtyEligibleForBetterDoc,
} from "@/modules/patients/detail/better-doc/lib/better-doc-sub-specialties"
import type { PointOfCareType } from "@/types/__generated__/union-types"

const GENERAL_PRACTITIONER_BETTER_DOC_SPECIALTY: BetterDocSpecialty = "GENERAL_INTERNAL_MEDICINE"

type BetterDocSpecialtyForPointOfCare = {
  betterDocSpecialty: BetterDocSpecialty | undefined
  isBetterDocSpecialtyFixed: boolean
}

export const getBetterDocSpecialty = (
  effectivePointOfCare: PointOfCareType | undefined,
  specialtyName: string | undefined,
): BetterDocSpecialtyForPointOfCare => {
  if (effectivePointOfCare === "GENERAL_PRACTITIONER") {
    return { betterDocSpecialty: GENERAL_PRACTITIONER_BETTER_DOC_SPECIALTY, isBetterDocSpecialtyFixed: true }
  }

  if (specialtyName !== undefined && isSpecialtyEligibleForBetterDoc(specialtyName)) {
    return { betterDocSpecialty: specialtyName, isBetterDocSpecialtyFixed: false }
  }

  return { betterDocSpecialty: undefined, isBetterDocSpecialtyFixed: false }
}
